<template>
  <label class="formLabel" v-if="label">
    <span v-if="isRequired" class="labelBadge--required">必須</span>
    <span v-if="showOptional" class="labelBadge--optional">任意</span>
    {{ label }}
  </label>
</template>

<script>
export default {
  name: 'form-label-fes',
  props: {
    label: String,
    showOptional: {
      type: Boolean,
      default: false
    },
    validation: {
      type: Object,
      default() {
        return { rules: {} }
      }
    },
    required: Boolean
  },
  computed: {
    isRequired() {
      return this.validation.required || this.required
    }
  }
}</script>

<style lang="scss" scoped>
.formLabel {
  line-height: 15px;
  font-size: 15px;
}

.badgeRequired {
  margin-right: 1em;

}
</style>



// WEBPACK FOOTER //
// resources/assets/js/uFes/components/FormLabelFes.vue